import styled from "@emotion/styled";
import { LdLabel, LdSelect } from "@liquid/react";

const StyledRequired = styled.span`
  &[data-required="true"] {
    :after {
      content: " *";
    }
  }
`;
const StyledSelect = styled(LdSelect)<{ width?: number | string }>`
  overflow: hidden;
  width: ${({ width }) => width};
`;

const StyledLabel = styled(LdLabel)`
  width: 100%;
`;

export { StyledRequired, StyledSelect, StyledLabel };
